import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import SharePointLogo from "@/assets/svg/external/Microsoft_Office_SharePoint_(2019–present).svg?react";

import { DocumentLocationType } from "@/model/Procedure/ProcedureUseDocument";

interface IDocumentListItemIcon {
	documentType: DocumentLocationType;
}

export const DocumentListItemIcon: React.FunctionComponent<
	IDocumentListItemIcon
> = (props) => {
	switch (props.documentType) {
		case "SharePoint": {
			return <SharePointLogo className="svg-icon svg-icon--logo" width="20" />;
		}
		default: {
			return (
				<InsertDriveFileIcon
					className="svg-icon svg-icon--logo"
					sx={{ width: "20px", height: "20px" }}
				/>
			);
		}
	}
};
